
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import httpClient from "../../HTTPService";
import { ToastContainer, toast } from 'react-toastify';
import noImage from "../../assets/noimage.jpg";
import { useEffect } from "react";
import Loding from '../../Component/Loding/Loding';
import AddEditSubscription from "../Subscription/AddEditSubscription";
import AddEditSubscriptionPvider from "../Subscription/providerSubcription";
const AddEditSubCategory = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const [categotyName, setCategotyName] = useState("");
    const [maincategotyName, mainCategotyName] = useState("");
    const [catStatus, setStatus] = useState("");
    const [catImage, setcatImage] = useState("");
    const [imagePrvw, setimagePrvw] = useState();
    const [itemId, setitemId] = useState('');
    const [editMode, seteditMode] = useState(false)
    const [allCat, setAllcat] = useState()
    const [loadingstate, setloadinigstate] = useState(false)
    const [amount, setAmount] = useState(0)
    const [rating, setRating] = useState(null)

    const [subcategory_deletedID, setsub_category_deleted] = useState([])
    const [subcategory_deletedIDprovider, setsub_category_deletedprovider] = useState([])

    const [subscription, setSubscriptiondetails] = useState({
        sub_name: '',
        subscription_des: '',
        sub_type: null
    })
    const [subscriptionprover, setSubscriptiondetailsprovider] = useState({
        sub_name: '',
        subscription_des: '',
        sub_type: null
    })
    const [useragree, setUseragree] = useState('')
    const [adinfo, setaddInfo] = useState('')
    // const []
    const [provideragrement, setprovideragreement] = useState('')
    // Edit Category
    const queryParams = new URLSearchParams(location.search); // Parse query string
    const id = queryParams.get('id');

    const [subscriptionData, setSubscriptionData] = useState([]);
    const [subscriptionDataprovider, setSubscriptionDataprovider] = useState([]);

    // This function will be called by the child
    const handleSubscriptionDataChange = (data) => {
        setSubscriptionData(data, 'sub data>>>>>>>>>>');
        // You can also do other things with the data here
    };
    const handleSubscriptionDataChangeprovider = (data) => {
        setSubscriptionDataprovider(data, 'sub data>>>>>>>>>>');
        // You can also do other things with the data here
    };
    const handlechangeDeletdsubcateryID = (data) => {
        setsub_category_deleted(data, 'sub data>>>>>>>>>>');
        // You can also do other things with the data here
    };
    const handlechangeDeletdsubcateryIDprovider = (data) => {
        setsub_category_deletedprovider(data, 'sub data>>>>>>>>>>');
        // You can also do other things with the data here
    };
    const subsdataOnchage = (data, type) => {
        if (type == 'name') {
            setSubscriptiondetails((prev) => {
                return {
                    ...prev,
                    sub_name: data
                }
            })
        } else if (type == 'sub_type') {
            setSubscriptiondetails((prev) => {
                return {
                    ...prev,
                    sub_type: data
                }
            })
        } else {
            setSubscriptiondetails((prev) => {
                return {
                    ...prev,
                    subscription_des: data
                }
            })
        }
    }

    const subsdataOnchagepriovider = (data, type) => {
        if (type == 'name') {
            setSubscriptiondetailsprovider((prev) => {
                return {
                    ...prev,
                    sub_name: data
                }
            })
        } else if (type == 'sub_type') {
            setSubscriptiondetailsprovider((prev) => {
                return {
                    ...prev,
                    sub_type: data
                }
            })
        }

        else {
            setSubscriptiondetailsprovider((prev) => {
                return {
                    ...prev,
                    subscription_des: data
                }
            })
        }
    }
    useEffect(() => {
        if (id != undefined) {
            setloadinigstate(true)
            httpClient.post("/admin/sub-categories/view", {
                "id": id
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }).then(async (res) => {
                setCategotyName(res.data.data.name)
                setaddInfo(res?.data?.data?.added_info)
                setUseragree(res?.data?.data?.user_agree_content)
                setprovideragreement(res?.data?.data?.provider_agree_content)
                setRating(res?.data?.data?.is_rating)
                let user_sub = await res?.data?.data?.master_subscriptions?.find(item => item?.subscription_type == 1)
                let provider_sub = await res?.data?.data?.master_subscriptions?.find(item => item?.subscription_type == 2)

                if (user_sub) {
                    setSubscriptiondetails(prev => {
                        return {
                            ...prev,
                            sub_name: user_sub?.name,
                            subscription_des: user_sub?.description,
                            sub_type: user_sub?.subscription_type

                        }
                    })

                    console.log(user_sub?.subscriptions, 'subcription data......')
                    setSubscriptionData(user_sub?.subscriptions)

                }
                if (provider_sub) {
                    setSubscriptiondetailsprovider(prev => {
                        return {
                            ...prev,
                            sub_name: provider_sub?.name,
                            subscription_des: provider_sub?.description,
                            sub_type: provider_sub?.subscription_type

                        }
                    })
                    setSubscriptionDataprovider(provider_sub?.subscriptions)


                }


                // setSubscriptionData(res?.data?.data?.master_subscription?.subscriptions)
                setimagePrvw(res.data.data.image_path)
                mainCategotyName(res.data.data.category_id)
                setAmount(res?.data?.data?.amount)
                setStatus(res?.data?.data?.active)
                setloadinigstate(false)
            })

        }
    }, [id])
    useEffect(() => {
        if (localStorage.getItem('editSubData')) {
            const currentData = JSON.parse(localStorage.getItem('editSubData'));
            setCategotyName(currentData.name)
            setimagePrvw(currentData.image_path)
            setitemId(currentData.id)
            mainCategotyName(currentData.category_id)
            seteditMode(true)
        }
        getallCat();
    }, [])

    // get all category
    const getallCat = async () => {
        try {
            const result = await httpClient.post("/admin/all-categories-list", {}, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            setAllcat(result.data.data)
        }
        catch (error) {

        }
    }
    // upload Image
    const uploadcat = (e) => {
        setcatImage(e.target.files)
        console.log(catImage);
        setimagePrvw(URL.createObjectURL(e.target.files[0]))

    }
    const addCatform = async (event) => {


        // let _payloadData = {

        //     name: categotyName,
        //     category_id: maincategotyName,
        //     subscription_name: subscription?.sub_name,
        //     subscription_description: subscription?.subscription_des,
        //     subscription_data: subscriptionData,
        //     added_info: adinfo,
        //     user_agree_content: useragree,
        //     provider_agree_content: provideragrement,
        //     is_rating: rating,
        //     amount: amount,
        //     active: catStatus,
        //     image: catImage[0]
        // }


        // event.preventDefault(  );
        if (id != undefined) {
            let _marge_array = [...subcategory_deletedID, ...subcategory_deletedIDprovider]
            let user_sub = {
                subscription_name: subscription?.sub_name,
                subscription_description: subscription?.subscription_des,
                sub_type: subscription?.sub_type,
                plans: subscriptionData
            }
            let provider_sub = {
                subscription_name: subscriptionprover?.sub_name,
                subscription_description: subscriptionprover?.subscription_des,
                sub_type: subscriptionprover?.sub_type,
                plans: subscriptionDataprovider
            }
            console.log(subcategory_deletedID, 'paln list data>>>>>>>>>>>>')
            const formData = new FormData();

            formData.append('id', id)
            formData.append('name', categotyName);
            formData.append('category_id', maincategotyName);

            formData.append('subscription_deleted_ids', JSON.stringify(_marge_array))
            formData.append('user_subscription', JSON.stringify(user_sub));
            formData.append('provider_subscription', JSON.stringify(provider_sub));
            formData.append('added_info', adinfo);
            formData.append('user_agree_content', useragree);
            formData.append('provider_agree_content', provideragrement);
            formData.append('is_rating', rating);
            formData.append('active', catStatus);
            formData.append('image', catImage[0]);
            try {
                const result = await httpClient.post("/admin/sub-categories/update", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Accept": "multipart/form-data",
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })
                if (result.data.status == true) {
                    localStorage.removeItem('editSubData')
                    setimagePrvw(null);
                    setCategotyName("")
                    document.getElementById('addForm').reset();
                    toast.success(result.data.message);
                    setTimeout(() => {
                        navigate('/subcategory')
                    }, 1000)

                }

                if (result.data.status == false) {
                    toast.error(result.data.message)
                }

            }
            catch (error) {
                toast.error(error.message)
            }
        }
        else {

            // let apyload_data = {
            //     user_sub: {
            //         subscription_name: subscription?.sub_name,
            //         subscription_description: subscription?.subscription_des,
            //         sub_type: subscription?.sub_type,
            //         plan: subscriptionData
            //     },
            //     provier: {
            //         subscription_name: subscriptionprover?.sub_name,
            //         subscription_description: subscriptionprover?.subscription_des,
            //         sub_type: subscriptionprover?.sub_type,
            //         plan: subscriptionDataprovider
            //     }
            // }

            let user_sub = {
                subscription_name: subscription?.sub_name,
                subscription_description: subscription?.subscription_des,
                sub_type: subscription?.sub_type,
                plans: subscriptionData
            }
            let provider_sub = {
                subscription_name: subscriptionprover?.sub_name,
                subscription_description: subscriptionprover?.subscription_des,
                sub_type: subscriptionprover?.sub_type,
                plans: subscriptionDataprovider
            }

            const formData = new FormData();
            formData.append('category_id', maincategotyName);
            formData.append('name', categotyName);
            formData.append('user_subscription', JSON.stringify(user_sub));
            formData.append('provider_subscription', JSON.stringify(provider_sub));
            formData.append('added_info', adinfo);
            formData.append('user_agree_content', useragree);
            formData.append('provider_agree_content', provideragrement);
            formData.append('is_rating', rating);
            formData.append('active', catStatus);
            formData.append('image', catImage[0]);

            try {
                const result = await httpClient.post("/admin/sub-categories/create", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "Accept": "multipart/form-data",
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }

                });

                if (result.data.status == true) {
                    mainCategotyName('')
                    setimagePrvw(null);
                    setCategotyName("")
                    document.getElementById('addForm').reset();
                    toast.success(result.data.message)
                    setTimeout(() => {
                        navigate('/subcategory')
                    }, 1000)
                }
                if (result.data.status == false) {
                    toast.error(result.data.message)
                }
            }
            catch (error) {
                toast.error(error.message)

            }
        }



    }

    const handleChange = (event) => {
        setRating(event.target.value);
    };
    return (
        <div className="cataddedit">
            <ToastContainer
                autoClose={1000}
            />
            {
                loadingstate ?
                    <Loding />
                    : null

            }
            <div className="card">
                <form onSubmit={addCatform} id="addForm">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="formGroup flxfrm">
                                <div className="catIcon">
                                    <img src={imagePrvw ? imagePrvw : noImage} />
                                </div>

                                <span className="uploadImage" onChange={(e) => { uploadcat(e) }}>

                                    <input type="file" name="image" />
                                    <p className="uploade-text">Upload Icon</p>
                                    <div className="upload-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-arrow-up" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M7.646 5.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 6.707V10.5a.5.5 0 0 1-1 0V6.707L6.354 7.854a.5.5 0 1 1-.708-.708z" />
                                            <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                        </svg>
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="formGroup">
                                <label>Category Name*</label>

                                <select value={maincategotyName} onChange={(val) => mainCategotyName(val.target.value)} required>
                                    <option>Select Category</option>
                                    {
                                        allCat?.map((item, i) => {
                                            return <option value={item.id} key={i}>{item.name}</option>
                                        })
                                    }

                                </select>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="formGroup">
                                <label>Sub Category Name*</label>
                                <input type="text" name="categotyName" placeholder="Name" onChange={(val) => setCategotyName(val.target.value)} value={categotyName} required />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="formGroup">
                                <label>Status*</label>
                                <select value={catStatus} onChange={(val) => setStatus(val.target.value)} >
                                    <option>Select Status</option>
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                </select>
                            </div>
                        </div>
                        {/* <div className="row"> */}
                        {/* <div className="col-md-3">
                            <div className="formGroup">
                                <label>Price (<span>&#8377;</span>)*</label>
                                <input type="number"
                                    name="amount"
                                    placeholder="Amount"
                                    onChange={(val) => setAmount(val.target.value)}
                                    value={amount}
                                    required
                                    onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}

                                />
                            </div>
                        </div> */}

                        <div className="col-md-9">
                            <div className="formGroup">
                                <label>Add info*</label>
                                <input
                                    type="text"
                                    value={adinfo}
                                    onChange={(value) => setaddInfo(value?.target?.value)}
                                    name="Add info"
                                    placeholder="Add info"
                                    // onChange={(val) => setAmount(val.target.value)}
                                    // value={amount}
                                    required

                                />
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div className="formGroup">
                                <label>I Agree(User)*</label>
                                <textarea
                                    type="text"
                                    value={useragree}
                                    onChange={(value) => setUseragree(value?.target?.value)}
                                    name="Add info"
                                    placeholder="User"
                                    // onChange={(val) => setAmount(val.target.value)}
                                    // value={amount}
                                    required

                                />
                            </div>
                        </div>


                        <div className="col-md-6">
                            <div className="formGroup">
                                <label>I Agree(Provider)*</label>
                                <textarea
                                    type="text"
                                    value={provideragrement}
                                    onChange={(value) => setprovideragreement(value?.target?.value)}
                                    name="Add info"
                                    placeholder="Provider"
                                    // onChange={(val) => setAmount(val.target.value)}
                                    // value={amount}
                                    required

                                />
                            </div>
                        </div>
                        <div className="col-md-2 ">
                            <div
                                className=" d-flex flex-column  "

                            >
                                <label>Rating </label>
                                <div className="d-flex flex-row justify-content-between mt-9">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="radioDefault"
                                            id="radioDefault1"
                                            value="1"
                                            checked={rating == '1'}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="radioDefault1">
                                            YES
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="radioDefault"
                                            id="radioDefault2"
                                            value="0"
                                            checked={rating == '0'}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor="radioDefault2">
                                            NO
                                        </label>
                                    </div>
                                </div>



                            </div>
                        </div>

                        {/* </div> */}



                    </div>


                </form>
                <div style={{
                    width: '100%',
                    backgroundColor: '#673ab7',
                    height: 50, justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    marginTop: 20
                }}>

                    <h5 style={{
                        color: '#FFFFFF',
                        fontWeight: '700'
                    }}> User Subscription</h5>
                </div>
                <AddEditSubscription
                    subscriptionDetails={subscription}
                    subscription_data={subscriptionData}
                    subsdataOnchage={subsdataOnchage}
                    handleSubscriptionDataChange={handleSubscriptionDataChange}
                    subcategory_deleted_onchange={handlechangeDeletdsubcateryID}
                />

                {/* provider subscription */}
                <div style={{
                    width: '100%',
                    backgroundColor: '#673ab7',
                    height: 50, justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                    marginTop: 20
                }}>

                    <h5 style={{
                        color: '#FFFFFF',
                        fontWeight: '700'
                    }}>Provider Subscription</h5>
                </div>
                <AddEditSubscriptionPvider
                    subscriptionDetails={subscriptionprover}
                    subscription_data={subscriptionDataprovider}
                    subsdataOnchage={subsdataOnchagepriovider}
                    handleSubscriptionDataChange={handleSubscriptionDataChangeprovider}
                    subcategory_deleted_onchange={handlechangeDeletdsubcateryIDprovider}
                />
                <div className="col-md-4">
                    <div className="btngrp">
                        <button type="button" className="themeBtn cancelBtn"
                        // onClick={() => { addCatform() }}

                        >Cancel</button>
                        <button type="button"
                            className="themeBtn"
                            onClick={() => { addCatform() }}
                        >{id != undefined ? "Update" : "Submit"}</button>
                    </div>

                </div>
            </div>
            {/* <div className='row'> */}

            {/* </div> */}
        </div>
    )
}
export default AddEditSubCategory;